<div class="header">
    <div class="row m-0 p-4 headerContainer">
        <div class="col-md-3 p-0 align-center logo">
            <a [routerLink]="['']">
                <img ngSrc="../../../../assets/images/trialresults_logo.png" height="53" width="203"
                    alt="TrialResults logo for accessing clinical trial results and plain language summaries" ngOptimizedImage/>
            </a>
        </div>
        <div class="col-md-6 p-0 searchBar">
            <div class="card top-card" *ngIf="isSearch">
                <div class="card-body">
                    <section id="search">
                        <label for="search-input">
                            <i-feather name="search" class="search-icon"></i-feather>
                        </label>
                        <input class="form-control search" type="text" #searchKey autocomplete="off"
                            value="{{searchSelectedKey}}" placeholder="Search" id="example-search-input"
                            (keyup)="updateSearch(searchKey)" (keyup.enter)="navigation(searchKey)"
                            (focus)="searchFocus()" (input)="onInputChange($event)" (blur)="searchBlur()">

                        <label class="search-arrow text-end c-pointer" (click)="navigation(searchKey)"
                            *ngIf="!isLoading">
                            <i-feather name="chevron-right" class="chevron-icon text-primary"></i-feather>
                        </label>
                        <label class=" loading-spinner text-end c-pointer" *ngIf="isLoading">
                            <i class="fa fa-spinner fa-pulse fa-x fa-fw"></i>
                            <span class="sr-only">Loading...</span>
                        </label>
                        <!-- <div class="card search-card border-0 pt-2" *ngIf="dataList.length > 0">
                            <ul class="list-group list-group-flush group scrollable" *ngFor="let item of dataList;">
                              <li class="list-group-item text-start item" (click)="navigation(item)">
                                {{ item.Identifier }}
                              </li>
                            </ul>
                          </div> -->
                    </section>
                    <div class="suggestion-box px-0">
                        <ng-container *ngIf="isSuggestionDisplayed">
                            <div *ngFor="let text of predictiveTexts" class="bg-white py-2 px-4 search-option"
                                (click)="selectSuggestion(text)">
                                {{text.Identifier}}-{{text.Title}}
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 p-0 pl-45 align-center-contact text-end contact">
            <a class="btn custom-button" href="https://www.trialassure.com/about/contact/" target="_blank">
                <i-feather name="phone" class="icons"></i-feather>Contact Us
            </a>
        </div>
    </div>
</div>